export const Logo = require('./logotipo_hands.svg');
export const LogoBranco = require('./logotipo_hands_branco.svg');
